import React, { useState } from 'react';
import { Sparkles, X } from 'lucide-react';

// In-app changelog. Add new entries to the TOP (newest first), dated YYYY-MM-DD.
// The unread dot = entries newer than the last date the user opened the panel.
const CHANGELOG = [
  { date: '2026-07-08', title: 'Refer & Earn, get paid 30%', body: 'Refer a dealer, earn 30% of their subscription every month for a year. Your link, a printable QR flyer, and a 25-sec how-to are on the Refer & Earn page.' },
  { date: '2026-07-08', title: 'Smarter AI scanning', body: 'The card scanner got a major accuracy upgrade, better year/set reads, and it now double-checks tricky cards against a catalog of real card photos.' },
  { date: '2026-06-26', title: 'Walmart Marketplace', body: 'List your cards on Walmart.com’s collectibles marketplace. Connect under Settings → Channels.' },
  { date: '2026-06-26', title: 'Pokémon & TCG listing', body: 'List Pokémon, Magic, Yu-Gi-Oh, One Piece & Lorcana cards to eBay, just pick the game in the Sport/Game field.' },
  { date: '2026-06-26', title: 'Auto-markdown old stock', body: 'Automatically drop the price on cards that sit too long. Set your day→% tiers on the Repricing page.' },
  { date: '2026-06-26', title: 'Inventory aging', body: 'New “Aging 90d+” filter and an Age column flag dead stock at a glance.' },
  { date: '2026-06-26', title: 'Print barcode labels', body: 'Select cards → Actions → Print Barcode Labels. Each label has the location, price, and a scannable barcode.' },
  { date: '2026-06-26', title: 'Tags & SKU codes', body: 'Tag cards your way, and auto-assign SKU codes from Settings → Listings.' },
  { date: '2026-06-26', title: 'Cross-listing report', body: 'See how many cards are listed on multiple channels, Settings → Channels.' },
];

const SEEN_KEY = 'whatsnew:seen';
const latestDate = CHANGELOG.reduce((m, e) => (e.date > m ? e.date : m), '');

export default function WhatsNew({ collapsed, isMobile, onOpenSomething, compact }) {
  const [open, setOpen] = useState(false);
  const [seen, setSeen] = useState(() => { try { return localStorage.getItem(SEEN_KEY) || ''; } catch (e) { return ''; } });
  const unread = CHANGELOG.filter(e => e.date > seen).length;

  const openPanel = () => {
    setOpen(true);
    try { localStorage.setItem(SEEN_KEY, latestDate); } catch (e) { /* ignore */ }
    setSeen(latestDate);
    if (isMobile && onOpenSomething) onOpenSomething();
  };

  const badge = unread > 0 && (
    <span style={{ position: 'absolute', top: -5, right: -6, minWidth: 15, height: 15, padding: '0 3px', borderRadius: 8, background: '#ef4444', color: '#fff', fontSize: 9, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>{unread}</span>
  );

  return (
    <>
      {compact ? (
        // Icon-only mode for the sidebar's compact utility row.
        <button onClick={openPanel} className="sidebar-util-btn" title="What’s New">
          <span style={{ position: 'relative', display: 'inline-flex' }}>
            <Sparkles size={18} strokeWidth={1.75} />
            {badge}
          </span>
        </button>
      ) : (
      <button
        onClick={openPanel}
        className="sidebar-link"
        title={(collapsed && !isMobile) ? 'What’s New' : undefined}
        style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit', position: 'relative' }}
      >
        <span style={{ position: 'relative', display: 'inline-flex' }}>
          <Sparkles size={21} strokeWidth={1.75} />
          {badge}
        </span>
        {(!collapsed || isMobile) && <span className="sidebar-link-label">What’s New</span>}
      </button>
      )}

      {open && (
        <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(13,27,62,0.45)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ width: 'min(440px, 100%)', maxHeight: '80vh', background: '#fff', borderRadius: 16, overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ background: 'linear-gradient(135deg, #0d1b3e 0%, #1a2e5c 100%)', color: '#fff', padding: '16px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                <Sparkles size={19} />
                <div style={{ fontWeight: 800, fontSize: 16 }}>What’s New</div>
              </div>
              <button onClick={() => setOpen(false)} style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', padding: 4 }}><X size={20} /></button>
            </div>
            <div style={{ overflowY: 'auto', padding: '8px 0' }}>
              {CHANGELOG.map((e, i) => (
                <div key={i} style={{ padding: '12px 18px', borderBottom: i < CHANGELOG.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#0d1b3e' }}>{e.title}</div>
                    <div style={{ fontSize: 11, color: '#94a3b8', whiteSpace: 'nowrap' }}>{new Date(e.date + 'T00:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}</div>
                  </div>
                  <div style={{ fontSize: 12.5, color: '#475569', lineHeight: 1.5, marginTop: 3 }}>{e.body}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
